import React, { Component } from "react";
import { Row, Col, Button, Form, Select, message, Input, InputNumber, Checkbox } from "antd";
import NumericInput from "../../../Components/NumericInput/NumericInput";
import { withRouter } from "react-router-dom";
import { API } from "../../../API/API";
const { TextArea } = Input;
class JoinWorkTaskAdd extends Component {
  formRef = React.createRef();
  state = {
    jointaskid: this.props.taskid,
    joinworkid: this.props.joinworkid,
    isEdit: this.props.isEdit,
    taskname: "",
    taskdetail: "",
    visible: true,
    dkey: 1,
  };
  componentDidMount = () => {
    this.getData();
  };
  getData = () => {
    API.get("/getJoinWorkTask?jointaskid=" + this.props.taskid).then(
      (response) => {
        if (response.status === 200) {
          if (response.data.retData.length > 0) {
            this.setState((prevState) => ({
              joinworkid: response.data.retData[0].joinworkid,
              taskname: response.data.retData[0].taskname,
              taskdetail: response.data.retData[0].taskdetail,
              dkey: prevState.dkey + 1,
            }));
          }
        }
      }
    );
  };
  onChangeValue = (field, value) => {
    this.setState({ [field]: value });
  };
  onSave = () => {
    if (this.state.taskname) 
      {
      let body = {
        jointaskid: this.state.jointaskid,
        joinworkid: this.state.joinworkid,
        taskname: this.state.taskname,
        taskdetail: this.state.taskdetail,
      };
      API.post("/saveJoinWorkTask", body).then((response) => {
        if (response.status === 200 && response.data.retType === 0) {
          message.success("Амжилттай хадгаллаа.");
          this.props.showForm(false, 0);
        }
      });
    }
  };

  render() {  
    const disabled = this.state.isEdit === true ? false : true;
    return (
      <div id="jointask" key={this.state.dkey}>
        <Form
          className="formDrawer"
          ref={this.formRef}
          onFinish={this.onSubmit}
          layout="vertical"
          initialValues={{}}
        >
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Form.Item
                style={{ fontWeight: 700 }}
                label="Хийгдэх ажил"
                name="taskname"
                initialValue={this.state.taskname}
              >
                <TextArea
                  onChange={(e) => this.onChangeValue("taskname", e.target.value)}
                  rows={3}
                  value={this.state.taskname}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Form.Item
                style={{ fontWeight: 700 }}
                label="Нэмэлт тайлбар"
                name="taskdetail"
                initialValue={this.state.taskdetail}
              >
                <TextArea
                  onChange={(e) => this.onChangeValue("taskdetail", e.target.value)}
                  rows={5}
                  value={this.state.taskdetail}
                />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item className="buttonForm" label=" ">
            <Button
              disabled={disabled}
              type="primary"
              className="btnPrimary"
              htmlType="submit"
              onClick={this.onSave}
            >Хадгалах
            </Button>
          </Form.Item>
        </Form>
      </div>
    );
  }
}

export default withRouter(JoinWorkTaskAdd);

